<div class="sem_dados">
  <img class="sem_dados__icone" *ngIf="field.src" [src]="field.src" />
  <p class="cs_label sem_dados__titulo" *ngIf="field.title">
    {{ field.title }}
  </p>
  <p class="cs_label sem_dados__descricao" *ngIf="field.label">
    {{ field.label }}
  </p>
  <!-- <button class="cs_botao" (click)="field.onClick ? field.onClick() : null">
        {{ field.buttonLabel ? field.buttonLabel : 'Saiba mais' }}
    </button> -->
</div>
